import React, { forwardRef, RefObject } from "react";
import MenuItemWithIcon, { MenuItemWithIconProps } from "designSystem/components/menu/MenuItemWithIcon";
import { C8Node } from "../typings";
import UserAvatar from "./UserAvatar";

interface UserMenuItemProps extends Partial<MenuItemWithIconProps> {
	user: C8Node;
}

const UserMenuItem = forwardRef((props: UserMenuItemProps, ref: RefObject<HTMLLIElement>) => {
	const {
		user,
		...otherProps
	} = props;

	return (
		<MenuItemWithIcon
			ref={ref}
			text={user.$Name}
			{...otherProps}
		>
			<UserAvatar user={user} />
		</MenuItemWithIcon>
	);
});

export default UserMenuItem;